import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles<{ isCollapsed: boolean }>()((theme, {
    isCollapsed,
}) => {
    return {
        childrenWrapper: {
            overflow: 'hidden',
        },
        resizeGrabContainer: {
            boxSizing: 'border-box',
            height: '100%',
            width: 25,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: `1px solid ${theme.palette.secondary[200]}`,
            borderLeftWidth: isCollapsed ? 1 : 0,
            borderColor: 'divider',
            cursor: !isCollapsed && 'col-resize',
            '&:hover': {
                backgroundColor: !isCollapsed && theme.palette.secondary[100],
            },
            backgroundColor: theme.palette.secondary[50],
        },
        collapseToggle: {
            pointerEvents: 'auto',
            width: 22,
            height: 50,
            '&:hover': {
                backgroundColor: theme.palette.secondary[200],
            },
            borderRadius: '4px !important',
        },
    }
})

export default useStyles
